<template>
    <div class="top" >
        <div class="top_main clearfix">
            <div class="top_logo" @click="goback"></div>
            <ul class="top_menu">
                <li v-for="(v,i) in menuList" :key="i" 
                    :class="{'active':v.id==id}" 
                    @click="goback(v.id)">
                    <a class="scrollA" >{{v.name}}</a>
                    <i></i>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props:['id'],
    data() {
        return {
            menuList:[{
                name:'首页',
                code:'main',
                id:0
            },{
                name:'智慧后勤',
                code:'zhhq',
                id:1
            },{
                name:'智慧图书馆',
                code:'zhtsg',
                id:2
            },{
                name:'其他业务领域',
                code:'other',
                id:3
            },{
                name:'客户',
                code:'customer',
                id:4
            },{
                name:'关于',
                code:'about',
                id:5
            }],
            menuText:0,
        }
    },
    mounted(){
        
    },
    methods: {
        goback(){
            this.$emit('topback')
            // this.$router.push('/')
        }
    }

}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/headTop.vue